/**
 * Workspace layout density tokens (WORKSPACE-DENSITY-OPTIMIZATION-001).
 * UI-only — не влияет на бизнес-логику и API.
 */

/**
 * Вертикальный резерв под chrome Workspace:
 * layout header, заголовок страницы, governance, KPI, будущий Inbox (~80px), реестры, отступы.
 */
export const WORKSPACE_VIEWPORT_CHROME_PX = 460;

/** Высота scroll-области очередей задач — viewport-driven с запасом под Inbox. */
export const WORKSPACE_TASK_LIST_VIEWPORT_HEIGHT = `clamp(320px, calc(100vh - ${WORKSPACE_VIEWPORT_CHROME_PX}px), 560px)`;

/** @deprecated Используйте WORKSPACE_TASK_LIST_VIEWPORT_HEIGHT */
export const WORKSPACE_SECTION_HEIGHT = WORKSPACE_TASK_LIST_VIEWPORT_HEIGHT;

export const WORKSPACE_TASK_CARD_BODY_PADDING_PX = 8;

export const WORKSPACE_TASK_GROUP_MARGIN_BOTTOM_PX = 4;

export const WORKSPACE_TASK_GROUP_EXPANDED_PADDING = '4px 10px 6px';

export const WORKSPACE_TASK_LIST_SCROLL_STYLE = {
  minHeight: WORKSPACE_TASK_LIST_VIEWPORT_HEIGHT,
  maxHeight: WORKSPACE_TASK_LIST_VIEWPORT_HEIGHT,
  overflowY: 'auto' as const,
};
